import { StyleSheet } from 'react-native'

export const inviteModalTabsStyles = StyleSheet.create({
  tabBar: {
    marginBottom: 20,
  },
})
